// extracted by mini-css-extract-plugin
export default {"lds__roller__wrapper":"Loading_lds__roller__wrapper__3RVza","lds__roller":"Loading_lds__roller__KyNmH","lds-roller":"Loading_lds-roller__gxT3W"};